// extracted by mini-css-extract-plugin
export default {"blob":"Image_blob__ikczJ","blob-img":"Image_blob-img__YUdZF","img":"Image_img__nmela"};